import Vue from 'vue'

let connectionTimer = null;

const getConnection = async () => {
  const Network = window.parent?.Capacitor?.Plugins?.Network
  if (!Network) {
    store.connection.connected = window.navigator.onLine
    return
  }
  const connection = await Network.getStatus()
  store.connection.connected = connection.connected
  store.connection.connectionType = connection.connectionType
}

const connectionLoop = () => {
  getConnection()

  connectionTimer = setTimeout(() => {
    connectionLoop()
  }, 500);
}

const store = new Vue.observable({
  ready: false,
  connection: {
    connected: false,
    connectionType: 'unknown'
  },
})

const Connection = {
  init: async () => {
    if (!store.ready && !connectionTimer) {
      store.ready = true
      connectionLoop()
    }
  },
  check: async () => {
    await getConnection()
    return store.connection
  },
  isConnected: () => store.connection.connected
}

export default Connection